export enum ESchemaTab {
  Configure = 'configure',
  DataHooks = 'data-hooks',
  GraphQLMutationHooks = 'graphql',
  Json = 'json',
  Settings = 'settings'
}
